import { CalloutComponentType } from "./callout-component-type.js";
const calloutComponentNestableTypes = [
  CalloutComponentType.NESTABLE_PANEL,
  CalloutComponentType.NESTABLE_WELL,
  CalloutComponentType.NESTABLE_TABS
];
export {
  calloutComponentNestableTypes
};
